import { Section, SectionHeader, SectionTitle } from "@/blocks/Section/Section";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

export function PlaygroundSectionDisconnectedBy() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Default</PlaygroundSubSectionTitle>
        <Section data-test="disconnected-by-section">
          <SectionHeader>
            <SectionTitle>Disconnected by</SectionTitle>
          </SectionHeader>
          <span className="text-xs font-medium">Agent</span>
        </Section>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>External</PlaygroundSubSectionTitle>
        <Section data-test="disconnected-by-section">
          <SectionHeader>
            <SectionTitle>Disconnected by</SectionTitle>
          </SectionHeader>
          <span className="text-xs font-medium">External</span>
        </Section>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>System</PlaygroundSubSectionTitle>
        <Section data-test="disconnected-by-section">
          <SectionHeader>
            <SectionTitle>Disconnected by</SectionTitle>
          </SectionHeader>
          <span className="text-xs font-medium">System</span>
        </Section>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
